import { useContext, useMemo } from "react";
import { AppContext } from "../App";

const DEFAULT_NOTICE = Object.freeze({
  title: "This page is down for maintenance",
  description: "We're working behind the scenes to improve this page. Please check back soon.",
});

// Add any path that should display the maintenance notice to this object.
// Example:
// "/hcp/"; {
//   title: "Resources are temporarily unavailable",
//   description; "We're carrying out some essential maintenance. Please try again later.",
// },
const MAINTENANCE_PAGES = {
  //  "/patient/": {
  //   title: "Down for maintenance",
  //    description: "Please check back later.",
  //  },
  //  "/hcp/": {
  //    title: "Down for maintenance",
  //    description: "Please check back later.",
  //  },
};

const normalisePath = (path) => {
  if (!path) {
    return "/";
  }

  if (path.length > 1 && path.endsWith("/")) {
    return path.replace(/\/+$/, "");
  }

  return path;
};

const resolveConfig = (path) => {
  if (!path) {
    return null;
  }

  const exactMatch = MAINTENANCE_PAGES[path];

  if (exactMatch) {
    return exactMatch;
  }

  const trailingSlashMatch = MAINTENANCE_PAGES[`${path}/`];

  if (trailingSlashMatch) {
    return trailingSlashMatch;
  }

  return null;
};

export default function useMaintenance() {
  const { location } = useContext(AppContext);
  const pathname = location?.pathname ?? "/";

  return useMemo(() => {
    const config = resolveConfig(normalisePath(pathname));

    if (!config) {
      return null;
    }

    if (config === true) {
      return DEFAULT_NOTICE;
    }

    return {
      title: config.title || DEFAULT_NOTICE.title,
      description: config.description || DEFAULT_NOTICE.description,
    };
  }, [pathname]);
}
